export const GET_DAY_PLANNER_DATA = 'GET_DAY_PLANNER_DATA';
export const GET_DAY_PLANNER_DATA_SUCCESS = 'GET_DAY_PLANNER_DATA_SUCCESS';
export const GET_DAY_PLANNER_DATA_FAILURE = 'GET_DAY_PLANNER_DATA_FAILURE';
export const TOGGLE_DAY_CONFIG_SIDE_PANEL = 'TOGGLE_DAY_CONFIG_SIDE_PANEL';
export const TOGGLE_ADD_DIVISIONS_SIDE_PANEL = 'TOGGLE_ADD_DIVISIONS_SIDE_PANEL';
export const TOGGLE_SUMMARY_SIDE_PANEL = 'TOGGLE_SUMMARY_SIDE_PANEL';
export const SAVE_DAY_PLANNER_CONFIG = 'SAVE_DAY_PLANNER_CONFIG';
export const SAVE_DAY_PLANNER_CONFIG_SUCCESS = 'SAVE_DAY_PLANNER_CONFIG_SUCCESS';
export const SAVE_DAY_PLANNER_CONFIG_CONFIRM_CLEAR = 'SAVE_DAY_PLANNER_CONFIG_CONFIRM_CLEAR';
export const SAVE_DAY_PLANNER_CONFIG_FAILURE = 'SAVE_DAY_PLANNER_CONFIG_FAILURE';
export const CREATE_UPDATE_VIRTUAL_DRAWS = 'CREATE_UPDATE_VIRTUAL_DRAWS';
export const CREATE_UPDATE_VIRTUAL_DRAWS_SUCCESS = 'CREATE_UPDATE_VIRTUAL_DRAWS_SUCCESS';
export const CREATE_UPDATE_VIRTUAL_DRAWS_FAILURE = 'CREATE_UPDATE_VIRTUAL_DRAWS_FAILURE';
export const UPDATE_DAY_PLAN_SUMMARY = 'UPDATE_DAY_PLAN_SUMMARY';
export const UPDATE_DAY_PLAN_SUMMARY_SUCCESS = 'UPDATE_DAY_PLAN_SUMMARY_SUCCESS';
export const UPDATE_DAY_PLAN_SUMMARY_FAILURE = 'UPDATE_DAY_PLAN_SUMMARY_FAILURE';
export const AUTO_SCHEDULE_VIRTUAL_DRAWS = 'AUTO_SCHEDULE_VIRTUAL_DRAWS';
export const AUTO_SCHEDULE_VIRTUAL_DRAWS_SUCCESS = 'AUTO_SCHEDULE_VIRTUAL_DRAWS_SUCCESS';
export const AUTO_SCHEDULE_VIRTUAL_DRAWS_FAILURE = 'AUTO_SCHEDULE_VIRTUAL_DRAWS_FAILURE';
export const UPDATE_DAY_PLAN = 'UPDATE_DAY_PLAN';
export const SET_SELECTED_SCHEDULED_VIRTUAL_DRAW = 'SET_SELECTED_SCHEDULED_VIRTUAL_DRAW';
export const SET_PREVIOUS_DAY = 'SET_PREVIOUS_DAY';
export const COPY_DAY_TO_SCHEDULE = 'COPY_DAY_TO_SCHEDULE';
export const COPY_DAY_TO_SCHEDULE_FAILURE = 'COPY_DAY_TO_SCHEDULE_FAILURE';
export const COPY_DAY_TO_SCHEDULE_SUCCESS = 'COPY_DAY_TO_SCHEDULE_SUCCESS';
